<app-icon-selected [optionsSelected]="optionsSelected" [type]="type" (selectedEmit)="selected($event)"></app-icon-selected>

<div [class]="'row py-05 g-'+grid">
    <div *ngFor="let option of options" class="col search-opt" [class.d-none]="optionsSelected.includes(option)">
        <button (click)="checkOpt(option)" type="button" [class]="'btn-food bg-'+option" [class.no-bg]="type==='conditions'">
            <img [src]="'assets/img/intern/icons/'+type+'/'+option+'.svg'" [alt]="option" class="icon">
        </button>
        <p>{{ option | Esp | titlecase }}</p>
    </div>
</div>